import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import './PremiumSuccess.css';

// Landing del success_url de Stripe Checkout (/premium/exito?session_id=cs_...).
// Confirma el pago contra el backend (GET /api/billing/confirm), que aplica el
// upgrade a user_premium de forma idempotente con el webhook, y refresca el
// user en el AuthContext para que el rol nuevo se refleje al instante.
export default function PremiumSuccess() {
  const { t } = useTranslation();
  const { confirmPremiumCheckout } = useAuth();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  // 'verifying' | 'success' | 'error'
  const [status, setStatus] = useState(sessionId ? 'verifying' : 'error');
  const ran = useRef(false);

  useEffect(() => {
    if (!sessionId || ran.current) return;
    ran.current = true; // StrictMode monta dos veces; confirmamos una sola.
    confirmPremiumCheckout(sessionId)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [sessionId, confirmPremiumCheckout]);

  return (
    <>
      <Helmet>
        <title>{t('premium_success.meta_title')}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <main className="premium-success">
        {status === 'verifying' && (
          <div className="premium-success__card">
            <div className="premium-success__spinner" aria-hidden="true" />
            <h1 className="premium-success__title">{t('premium_success.verifying_title')}</h1>
            <p className="premium-success__text">{t('premium_success.verifying_text')}</p>
          </div>
        )}

        {status === 'success' && (
          <div className="premium-success__card">
            <div className="premium-success__badge" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 20 20" fill="none">
                <path d="M4 10.5l3.5 3.5L16 5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="premium-success__eyebrow">{t('premium_success.eyebrow')}</span>
            <h1 className="premium-success__title">{t('premium_success.title')}</h1>
            <p className="premium-success__text">{t('premium_success.text')}</p>
            <Link className="premium-success__cta" to="/profile">
              {t('premium_success.cta_profile')}
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="premium-success__card">
            <h1 className="premium-success__title">{t('premium_success.error_title')}</h1>
            <p className="premium-success__text">{t('premium_success.error_text')}</p>
            <Link className="premium-success__cta premium-success__cta--ghost" to="/precios">
              {t('premium_success.cta_back')}
            </Link>
          </div>
        )}
      </main>
    </>
  );
}
